import { css } from 'styled-components';
import { SpacingName } from '../../theme/constants';
import { TypographyName } from '../../theme/typography';
import { getTypography, getSpacing, rgba } from '../../theme/utils';
export const base = _ref => {
  let {
    theme,
    disabled,
    $error
  } = _ref;
  return css(["", " ", " color:", ";border:1px solid ", ";box-sizing:border-box;width:100%;border-radius:.3rem;outline:0;appearance:none;-moz-appearance:none;-webkit-appearance:none;&::placeholder{color:", ";}&:focus{box-shadow:0px 0 4px ", ";border:1px solid ", ";}", " ", ""], getTypography(theme, TypographyName.BODY), getSpacing.padding(theme, SpacingName.SMALLER), theme.palettes.neutrals.darkest, theme.palettes.neutrals.medium, theme.palettes.neutrals.medium, rgba(theme.palettes.neutrals.darkest, 0.3), theme.palettes.neutrals.medium, disabled && `
    background-color: ${rgba(theme.palettes.status.disabled, 0.3)};
    border: 1px solid ${theme.palettes.neutrals.lighter};
    color: ${theme.palettes.neutrals.medium};
    user-select: none;
    resize: none;

    &::placeholder {
      color: ${theme.palettes.neutrals.light};
    }
  `, $error && `
    border: 1px solid ${theme.palettes.status.alert};
  `);
};
//# sourceMappingURL=TextArea.style.js.map